import { useCallback, useEffect, useRef, useState } from "react";

// Runs one async action at a time (e.g. the Energia buttons on the Adaptive Test tab).
// `busy` is false, or the `key` passed to run() (true by default), so a page can tell which action is running.
// `work` resolves to true when it has sent the browser to another site; the guard then stays on
// so the buttons remain disabled while the page navigates away. If the user comes Back and the
// browser restores this page from its back/forward cache, the guard is released.
export default function useOneAtATime() {
  const busyRef = useRef(false);
  const [busy, setBusy] = useState(false);

  const release = useCallback(() => {
    busyRef.current = false;
    setBusy(false);
  }, []);

  useEffect(() => {
    const onPageShow = (event) => {
      if (event.persisted) release();
    };
    window.addEventListener("pageshow", onPageShow);
    return () => window.removeEventListener("pageshow", onPageShow);
  }, [release]);

  const run = useCallback(
    async (work, key = true) => {
      if (busyRef.current) return;
      busyRef.current = true;
      setBusy(key);
      let redirecting = false;
      try {
        redirecting = await work();
      } finally {
        if (!redirecting) release();
      }
    },
    [release]
  );

  return { busy, run };
}
